import React from 'react';
import ContactView from './ContactView';

const headerStyle = {
  textAlign: "right"
};

const tableHeadStyle = {
  textTransform: "none"
};

class ContactSection extends React.Component {

  constructor(props) {
    super(props);

    this.onDelete = this.onDelete.bind(this);
  }

  onDelete(task) {
    if (this.props.allowDelete && this.props.onDelete) {
      this.props.onDelete(task);
    }
  }

  render() {

    const { section, onDelete, ...rest } = this.props;
    const contacts = section.contacts || [];

    return (
      <article className="row">
        <header style={headerStyle}>
          <time><strong>{section.name}</strong></time>
          <span></span>
        </header>
        <table>
          <thead>
            <tr>
              <th style={tableHeadStyle}>Name</th>
              <th style={tableHeadStyle}>Email</th>
              <th style={tableHeadStyle}>Phone</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {contacts.map((contact, index) => (
              <ContactView
                {...rest}
                key={index}
                contact={contact}
                onDelete={this.onDelete} />
            ))}
          </tbody>
        </table>
      </article>
    );
  }
}

export default ContactSection;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectContacts/ContactSection.js